import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./BannerManagementReducer";
import {
  resetPageAndLimit,
  resetSearchFilters,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
} from "../YouTubeManagement/YouTubeManagementActions";

export function getBannerList(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_BANNERS_LIST_PENDING,
      payload: {
        getBannersListPending: false,
        getBannersListSuccess: false,
        getBannersListError: null,
        bannersList: [],
      },
    });
    dispatch(showLoader());

    Api.post(`banner/bannerList`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_BANNERS_LIST_SUCCESS,
          payload: {
            getBannersListPending: false,
            getBannersListSuccess: true,
            getBannersListError: null,
            bannersList: response.data,
          },
        });
        dispatch(resetPageAndLimit());
        dispatch(resetSearchFilters());
        dispatch(resetActiveNavigationTab());
        dispatch(resetSearchFilterForVideosByUrl());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_BANNERS_LIST_ERROR,
          payload: {
            getBannersListPending: false,
            getBannersListSuccess: true,
            getBannersListError: null,
            bannersList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch banners data",
          })
        );
      });
  };
}

export function getBannerById(id) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_BANNERS_BY_ID_PENDING,
      payload: {
        getBannersByIdPending: true,
        getBannersByIdSuccess: false,
        getBannersByIdError: null,
        bannerById: null,
      },
    });
    dispatch(showLoader());

    Api.get(`banner/getBannerById/${id}`)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_BANNERS_BY_ID_SUCCESS,
          payload: {
            getBannersByIdPending: false,
            getBannersByIdSuccess: true,
            getBannersByIdError: null,
            bannerById: response.data,
          },
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_BANNERS_BY_ID_ERROR,
          payload: {
            getBannersByIdPending: false,
            getBannersByIdSuccess: false,
            getBannersByIdError: null,
            bannerById: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch banners data",
          })
        );
      });
  };
}

export function uploadBanner(formData, callback) {
  // console.log("formData", formData);
  // // To verify, iterate through the FormData
  // for (let [key, value] of formData.entries()) {
  //   console.log(`${key}: ${value}`);
  //   if (key === "file") {
  //     console.log("File object details:", value);
  //   }
  // }

  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_BANNER_PENDING,
      payload: {
        addBannerPending: true,
        addBannerSuccess: false,
        addBannerError: null,
      },
    });
    dispatch(showLoader());

    await Api.post(`banner/uploadBanner`, formData)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_BANNER_SUCCESS,
          payload: {
            addBannerPending: false,
            addBannerSuccess: true,
            addBannerError: null,
          },
        });

        if (response.message === "Successfully uploaded banner") {
          callback();
          dispatch(
            showAlert({
              isOpen: true,
              title: "Success",
              type: "success",
              msg: response.message,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_BANNER_ERROR,
          payload: {
            addBannerPending: false,
            addBannerSuccess: false,
            addBannerError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to upload banner",
          })
        );
      });
  };
}

export function updateBanner(id, formData, callback) {
  // console.log("formData", formData);

  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_BANNER_PENDING,
      payload: {
        updateBannerPending: true,
        updateBannerSuccess: false,
        updateBannerError: null,
      },
    });
    dispatch(showLoader());

    await Api.post(`banner/updateBanner/${id}`, formData)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.UPDATE_BANNER_SUCCESS,
          payload: {
            updateBannerPending: false,
            updateBannerSuccess: true,
            updateBannerError: null,
          },
        });

        if (response.message === "Successfully updated banner") {
          callback();
          dispatch(
            showAlert({
              isOpen: true,
              title: "Success",
              type: "success",
              msg: response.message,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.UPDATE_BANNER_ERROR,
          payload: {
            updateBannerPending: false,
            updateBannerSuccess: false,
            updateBannerError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to update banner",
          })
        );
      });
  };
}

export function deleteBanner(id, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_BANNER_PENDING,
      payload: {
        deleteBannerPending: true,
        deleteBannerSuccess: false,
        deleteBannerError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`banner/deleteBanner/${id}`)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_BANNER_SUCCESS,
          payload: {
            deleteBannerPending: false,
            deleteBannerSuccess: true,
            deleteBannerError: null,
          },
        });

        dispatch(
          showAlert({
            isOpen: true,
            title: "Sucess",
            type: "success",
            msg: response.message,
          })
        );

        callback();
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_BANNER_ERROR,
          payload: {
            deleteBannerPending: false,
            deleteBannerSuccess: false,
            deleteBannerError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function setSearchFilters(data) {
  const { titleSearch } = data;
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SEARCH_FILTERS,
      payload: {
        titleSearch: titleSearch,
      },
    });
  };
}

export function setRowReordered(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_ROW_REORDER,
      payload: {
        rowReordered: data,
      },
    });
  };
}

export function setRowReorderWarningModal(data, link) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SHOW_ROW_REORDER_MODAL,
      payload: {
        showRowReorderedModal: data,
        redirectLink: link,
      },
    });
  };
}

export function setBannerScreenFilter(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_BANNER_SCREEN_FILTER,
      payload: {
        bannerScreenFilter: data,
      },
    });
  };
}

export function resetBannerScreenFilter() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_BANNER_SCREEN_FILTER,
      payload: {
        bannerScreenFilter: "",
      },
    });
  };
}

export function setBannerBackgroundColor(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_BANNER_BACKGROUND_COLOR,
      payload: {
        bgColor: data,
      },
    });
  };
}

export function resetBannerBackgroundColor() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_BANNER_BACKGROUND_COLOR,
      payload: {
        bgColor: "",
      },
    });
  };
}
